export default {
  auth0Enabled: (...args) => args[3]['auth0/enabled'],
  isLoggedIn: (...args) => {
    const auth0Enabled = args[3]['auth0/enabled'];
    return auth0Enabled ? args[3]['cs-session/isLoggedIn'] : args[3]['session/isTokenNotExpired']();
  }
};
